module.exports = __webpack_public_path__ + "static/media/scm_logo.1362c8d8.png";